import { render, staticRenderFns } from "./InviteDetailed.vue?vue&type=template&id=ef49f120&scoped=true&"
import script from "./InviteDetailed.vue?vue&type=script&lang=js&"
export * from "./InviteDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef49f120",
  null
  
)

export default component.exports